export enum ResponseStatus {
    None = "none",
    Organizer = "organizer",
    TentativelyAccepted = "tentativelyAccepted",
    Accepted = "accepted",
    Declined = "declined",
    NotResponded = "notResponded",
}

type AgendaItemResponseStatusProps = {
    response: ResponseStatus;
    time: string;
};

export default class AgendaItemResponseStatus {
    response: ResponseStatus;

    time: string;

    constructor({ response, time }: AgendaItemResponseStatusProps) {
        this.response = response;
        this.time = time;
    }
}
